import 'mapbox-gl/dist/mapbox-gl.css'
import css from './Map.module.scss'
import React, { Dispatch, SetStateAction, useRef, useState } from 'react'
import { Map as ReactMap, MapRef } from 'react-map-gl/mapbox'
import classNames from 'classnames'
import mapboxgl from 'mapbox-gl'

import { useGetPhotoPoints } from 'client/store/projects/hooks/photoPoints'

import { useHasGallery } from './hooks/useHasGallery'
import { useLoadPhotoPoints } from './hooks/useLoadPhotoPoints'
import { useOnClick } from './hooks/useOnClick'
import { useRestoreSnapshot } from './hooks/useRestoreSnapshot'
import { useUpdateCursorStyle } from './hooks/useUpdateCursorStyle'
import { MapPropsDefault } from './mapPropsDefault'
import { MapSnapshot, PropsMapHook } from './types'

type Props = {
  setMapRef: Dispatch<SetStateAction<MapRef | undefined>>
}

mapboxgl.accessToken = import.meta.env.VITE_MAPBOXGL_ACCESSTOKEN
const projectName = 'alter_egos'

const Map: React.FC<Props> = (props) => {
  const { setMapRef } = props

  const { data } = useGetPhotoPoints({ projectName })
  const mapRef = useRef<MapRef | null>(null)
  const snapshotRef = useRef<MapSnapshot | null>(null)
  const [loaded, setLoaded] = useState<boolean>(false)

  const propsHooks: PropsMapHook = { loaded, mapRef, snapshotRef }
  useLoadPhotoPoints({ ...propsHooks, data, setMapRef })
  useUpdateCursorStyle(propsHooks)
  useOnClick({ ...propsHooks, projectName })
  useRestoreSnapshot(propsHooks)
  const hasGallery = useHasGallery(propsHooks)

  return (
    <div className={classNames(css.mapContainer, { [css.withGallery]: hasGallery })}>
      <ReactMap
        attributionControl={false}
        fog={MapPropsDefault.fog}
        initialViewState={MapPropsDefault.initialViewState}
        mapLib={mapboxgl}
        mapStyle="mapbox://styles/minotogna/cm26dchlu002l01p72yi771yi"
        // mapStyle="mapbox://styles/minotogna/cm26dchlu002l01p72yi771yi/draft"
        maxZoom={MapPropsDefault.maxZoom}
        minZoom={MapPropsDefault.minZoom}
        onLoad={() => {
          setLoaded(true)
        }}
        ref={mapRef}
      />
    </div>
  )
}

export default Map
